import React from "react";
import './multiSelect.css'
import { color } from "../../utils/themes/color";
import { Select } from "antd";

export default function MULTISELECT(props) {
 
    return (
        <Select
            mode={"multiple"}
            options={props.options != undefined && props.options != null ? props.options : ""}
            placeholder={props.placeholder != undefined && props.placeholder != null ? props.placeholder : ""}
            className="m-multi-select"
            onChange={(e) => props.click(e)}
            value={props.value != undefined ? props.value : ""}
            style={{ color: color.primary }}>
             
        </Select>
    )
}